(() => {
  const initWinnersTabs = (root) => {
    const tabs = [...root.querySelectorAll("[data-gnr-winner-tab]")];
    const panels = [...root.querySelectorAll("[data-gnr-winner-panel]")];
    if (!tabs.length || !panels.length) return;

    const activate = (key) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.gnrWinnerTab === key;
        tab.classList.toggle("is-active", active);
        tab.setAttribute("aria-selected", active ? "true" : "false");
      });
      panels.forEach((panel) => {
        const active = panel.dataset.gnrWinnerPanel === key;
        panel.classList.toggle("is-active", active);
        panel.hidden = !active;
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => activate(tab.dataset.gnrWinnerTab));
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll("[data-gnr-winners]").forEach((root) => {
      if (root.dataset.initialized === "true") return;
      root.dataset.initialized = "true";
      initWinnersTabs(root);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
